import { apiService } from '@/api/apiService';
import { ApiResponseType } from '@/types/sharedTypes';

export type StartSecureLinkVerificationResponseType = { session_id: string; status: string; phone_masked: string };

export const startSecureLinkVerificationApi = (
  token: string,
  mobilePhone: string
): Promise<ApiResponseType<StartSecureLinkVerificationResponseType>> => {
  return apiService.POST(`/secure-links/${token}/verify/start/`, { mobile_phone: mobilePhone });
};
